import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/tara';

const initialState = false;

const setHasCuratedTickets = (state, action) => action.payload.hasCuratedTickets;

const handlers = {
  [types.TARA_SET_HAS_CURATED_TICKETS]: setHasCuratedTickets,
};

const hasCuratedTickets = createReducer(initialState, handlers);

export default hasCuratedTickets;

export const getTaraHasCuratedTickets = state => state.tara.hasCuratedTickets;



// WEBPACK FOOTER //
// ./src/reducers/tara/hasCuratedTickets.js